(ns ui.components.input.file-input
  (:require
    [clojure.string :as string]
    [common.localization :as loc]
    [frontend.utils :as fu]
    [oops.core :as oops]
    [ui.dom-globals :as dg]))

(defn upload-input
  [{:keys [on-change input-id accept-file-types class multi-file?]}]
  (let [accept (some->> accept-file-types
                        (map (fn [ft]
                               (str "." (name ft))))
                        (seq)
                        (string/join ", "))]
    [:input
     (merge
       {:type      "file"
        :multiple  (true? multi-file?)
        :on-drop   (fn [e]
                     (dg/persist-event e)
                     (dg/prevent-and-stop e)
                     (let [files (dg/event-transfer-files e)
                           len (oops/oget files "length")]
                       (on-change {:files          (->> (range 0 len)
                                                        (mapv (fn [i]
                                                                (aget files i))))
                                   :original-event e})))
        :on-focus  (fn [e]
                     (dg/prevent-default e)
                     (.setTimeout js/window
                                  (fn []
                                    (.blur (dg/element-by-id input-id)))
                                  300)
                     false)
        :id        input-id
        :on-change (fn [e]
                     (dg/persist-event e)
                     (dg/prevent-and-stop e)
                     (let [files (dg/event-target-files e)
                           len (oops/oget files "length")]
                       (on-change {:files          (->> (range 0 len)
                                                        (mapv (fn [i]
                                                                (aget files i))))
                                   :original-event e})))}
       (when class
         {:class class})
       (when accept
         {:accept accept}))]))

(defn upload-zone
  [{:keys [_lang-kw _info _css-class _accept-file-types _multi-file? _on-change]}]
  (let [input-id (str "input-id-" (gensym))]
    (fn [{:keys [lang-kw info css-class accept-file-types multi-file? on-change]}]
      (let [lang-kw (or lang-kw :en)]
        [:form
         {:action       "/api/attachment"
          :class-name   (fu/cs "flex flex-1 relative dashed" css-class)
          :on-drag-over dg/prevent-default
          :on-drop      (fn [e]
                          (dg/persist-event e)
                          (on-change {:files          (dg/event-transfer-files e)
                                      :original-event e})
                          (dg/prevent-and-stop e))}
         [:label
          {:for     input-id
           :class   "flex flex-1 h-15 justify-center border-dashed border-base-accent-text border-2 rounded mt-4"
           :on-drop (fn [e]
                      (dg/persist-event e)
                      (on-change {:files          (dg/event-transfer-files e)
                                  :original-event e})
                      (dg/prevent-and-stop e))}
          [:div
           {:class "text-base-light-text p-3 text-center"}
           [:i
            {:class "fal fa-cloud-upload w-auto block text-center text-base-light-text-paler text-4xl mb-2"}]
           [:span
            (loc/tr :dropzone-instructions-pre-link nil lang-kw)]
           [:span
            {:class "block text-base-light-text-accent bold cursor-pointer"}
            (loc/tr :dropzone-instructions-link nil lang-kw)]

           [:span
            {:class "block pt-2 text-base-light-text text-md"}
            (when info
              info)]
           [upload-input
            {:on-change         on-change
             :input-id          input-id
             :accept-file-types accept-file-types
             :multi-file?       multi-file?
             :class             "hidden"}]]]]))))

(defn view
  [{:keys [_ref _dom-id _class _placeholder _trigger _multiple? _auto-focus? _variant _disabled? _read-only? _transparent? _full-width? _on-change _on-focus _on-blur _on-key-down _label]}]
  (let [input-id (str "input-id-" (gensym))]
    (fn [{:keys [trigger info css-class accept-file-types multi-file? on-change]}]
      [:form
       {:action       "/api/attachment"
        :class-name   (fu/cs "flex flex-1 relative dashed" css-class)
        :on-drag-over dg/prevent-default
        :on-drop      (fn [e]
                        (dg/persist-event e)
                        (on-change {:files          (dg/event-transfer-files e)
                                    :original-event e})
                        (dg/prevent-and-stop e))}
       [:label
        {:for     input-id
         :class   "flex flex-1 justify-center"
         :on-drop (fn [e]
                    (dg/persist-event e)
                    (on-change {:files          (dg/event-transfer-files e)
                                :original-event e})
                    (dg/prevent-and-stop e))}
        [:div
         {:class "text-base-light-text text-center"}
         trigger

         [:span
          {:class "block pt-2 text-base-light-text text-md"}
          (when info
            info)]
         [upload-input
          {:on-change         on-change
           :input-id          input-id
           :accept-file-types accept-file-types
           :multi-file?       multi-file?
           :class             "hidden"}]]]])))
